
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 37 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","d":"M28.431 1.89l-3.523 7.442M20.363 3.537l-3.523 7.442M12.295 5.184l-3.523 7.442"}}),_c('path',{staticClass:"fill",attrs:{"fill":"#000","d":"M14.67 19.708l9.057 5.764-9.058 5.764z"}}),_c('path',{attrs:{"stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","d":"M2.318 13.944h32.938V37H2.318zM34.022 7.472L2.318 13.944 1 7.49 32.79 1z"}})])])
          )
        }
      }
    